import { bl_cms_form_template_ext_RowClass, bl_cms_form_template_hdr_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class CmsFormTemplateContainerModel extends BaseContainerModel {
    bl_cms_form_template_hdr: bl_cms_form_template_hdr_RowClass = new bl_cms_form_template_hdr_RowClass();
    bl_cms_form_template_exts: bl_cms_form_template_ext_RowClass[] = [];
}